import React, { useContext } from 'react';
import Form from './Form/Form';
import './ContactUs.css';
import { LanguageContext } from '../../../Contexts/LanguageContext';

const ContactUs = () => {
    const [isBangla, setIsBangla] = useContext(LanguageContext)
    return (
        <div className="container" id="contact">
            <div className="row">
                <div className="col-md-5 mb-5">
                    <div className="container">
                        <h1>{isBangla? "ইমেইল অ্যাড্রেস:" : "Email Address:" }</h1>
                        <a href="mailto:biotech.pharma@yahoo.com" className="contact-detail-link">biotech.pharma@yahoo.com</a>
                        <h1 className="mt-4">{isBangla ? "ফেসবুক:" : "Facebook:"}</h1>
                        <a href="https://facebook.com/bdbiotechph" className="contact-detail-link" target="_blank">{isBangla ? "ফেসবুক" : "Facebook"}</a>
                    </div>
                </div>
                <div className="col-md-7">
                    <Form />
                </div>
            </div>
        </div>
    );
};

export default ContactUs;